import React, { useCallback, useEffect, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useSearchParams, useNavigate } from 'react-router-dom'
import {jwtDecode, JwtPayload } from 'jwt-decode'
import { Box, Flex } from '@chakra-ui/react'

import { removePlusSign } from 'utils/functions/formatNumber'
import { getCollaboratorInformation, validateTokenValidate, expiredToken } from 'services/api'
import { useSubscriberContext } from 'providers/SubscriberProvider'
import { IValidateToken, IReturnValidateToken } from 'services/IApi.d'
import RegisterSuscription from 'components/subscription/RegisterSuscription/registerSubscription'
import Form from 'providers/FormProvider'
import { setToken } from 'utils/authentication'
import { IAdditionalParameters, IParamsMvi } from './Validate.d'
import { isSuccessStatus } from 'utils/functions/validations'

interface JwtTokenValidate extends JwtPayload {
  canal?: string;
  fechaHoraSolicitud?: string;
  parametrosAdicionales?: string;
  requestId?: string;
}


const ValidateCollaborator = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const code: string = searchParams.get('code')
  const { setFlow, setAdminCollaboratorData, setCollaboratorId, setSubscriberData } = useSubscriberContext()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const [loading, setLoading] = useState<boolean>(false)
  const [paramsMvi, setParamsMvi] = useState<IParamsMvi>(null)
  
  const handleReCaptchaVerify = useCallback(async (action: string) => {
    if (!executeRecaptcha) {
      console.info('Execute recaptcha not yet available')
      return ''
    }
    const token: string = await executeRecaptcha(action)
    return token
  }, [executeRecaptcha])

  useEffect(() => {
    setFlow('administrator')
  }, [setFlow])

  const initValues = {
    nacionality: 'Argentina',
    document: '',
    documentForeign: '',
    documentType: 'cuil',
  }

  const getCollaboratorInfo = async (collaboratorId: string) => {
    const response = await getCollaboratorInformation(collaboratorId)
    response.data.telefono = removePlusSign(response.data.telefono)
    response.data.codPais = removePlusSign(response.data.codPais)
    return response?.data
  }

  const loadValidateToken = async (validateTokenData: IValidateToken) => {
    try {
      const recaptchaToken: string = await handleReCaptchaVerify('validate_collaborator')
      const response: IReturnValidateToken = await validateTokenValidate(validateTokenData, { headers: { 'x-recaptcha-token': recaptchaToken } })
      if (!response?.data?.esTokenValido) {
        const responseData = await expiredToken(localStorage.getItem("idRepresentante"), +localStorage.getItem("role"), { headers: { 'x-recaptcha-token': recaptchaToken } })
        if(responseData) {
          navigate('/suscripcion/error-correo')
        }
      }
      if (!isSuccessStatus(response.status)) {
        navigate('/suscripcion/error-correo', { state: { pageBefore: 'recoveryUser500' } })
      }
      return response
    } catch (e) {
      throw new Error(e)
    }
  }

  useEffect(() => {
    if (!executeRecaptcha) {
      return
    }
    const decoded = jwtDecode<JwtTokenValidate>(code)
    const { canal, fechaHoraSolicitud, parametrosAdicionales, requestId } = decoded
    const splitData = parametrosAdicionales.split('&')
    const personalData: IAdditionalParameters = JSON.parse(splitData[0])
    //
    localStorage.setItem('role', personalData.role)
    localStorage.setItem('idEmpresa', personalData.idEmpresa)
    localStorage.setItem('idSuscriptor', personalData.idSuscriptor)
    localStorage.setItem('idRepresentante', personalData.idRepresentante)
    localStorage.setItem('companyCuit', personalData.companyCuit)
    localStorage.setItem('empresa', personalData.empresa)
    //
    const company = personalData.empresa
    const documento = (personalData.documentType).toLowerCase() === 'documento' ? 'DU' : 'PAS'
    if(!loading){
      loadValidateToken({
        canal,
        fechaHoraToken: fechaHoraSolicitud,
        requestId,
        token: code,
      }).then((response: IReturnValidateToken) => {
        // rol 1 ===> Admin ==== rol 2 ==> RL
        setSubscriberData({ company })
        setToken(response.data.token, response.data.tokenType)
        setCollaboratorId(requestId)
        getCollaboratorInfo(requestId)
          .then(setAdminCollaboratorData)
        if (+personalData.role === 1) {
          navigate('/suscripcion/crear-administrador?estado=VALIDADO')
          return
        }            
        const appName = +personalData.role === 2 ? 'onboarding2' : 'onboarding2admin'
        setParamsMvi({ appName, country: (personalData.country).toUpperCase(), documentType: documento, document: personalData.document, lastName: personalData.lastName })
        setLoading(true)
      })
    }
  }, [executeRecaptcha]) 

  return (loading && 
    <Flex>
      <Box flex='1' id='right-side' px='6' py='0' data-testid='rol-rel'>
        <Form initialValues={initValues}>
           <RegisterSuscription  isRecoveryUser isNewAccount shouldValidateCollaborator paramsMvi={paramsMvi} />
        </Form>
      </Box>
    </Flex>
  )
}

export default ValidateCollaborator